export default "__VITE_ASSET__daecebb9__"